import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import CartLot from '../cart-lot';
import { ReactComponent as CartBigIcon } from 'src/assets/icons/cart-big.svg';

import cartStore from 'src/stores/cart-store';

import { LOCALES } from 'src/constants';
import type { CartProps } from './cart.props';

import './cart.scss';

const Cart = observer(({ className, onAnimationEnd }: CartProps) => {
  const { isCartEmpty, cartData, decrementLot, incrementLot, removeLot } = cartStore;

  return (
    <div
      className={classNames('cart scrollbar', className, isCartEmpty && 'cart_empty')}
      onAnimationEnd={onAnimationEnd}
    >
      {isCartEmpty ? (
        <>
          <CartBigIcon />
          <div className="cart__message">
            {LOCALES.CART_EMPTY},
            <br /> {LOCALES.ADD_SERVICES_TO_ORDER}
          </div>
        </>
      ) : (
        cartData.map(({ lots, title }) => (
          <div className="cart__category" key={title}>
            <div className="cart__category-title">{title}</div>
            <div className="cart__category-lots">
              {lots.map(({ count, id, maxAmount, price, name }) => (
                <CartLot
                  key={id}
                  count={count}
                  maxCount={maxAmount}
                  name={name}
                  price={price}
                  onDecrement={() => decrementLot(id, true)}
                  onIncrement={() => incrementLot(id)}
                  onRemove={() => removeLot(id)}
                />
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
});

export default Cart;
